import { gql } from '@apollo/client'
import {
    listingMatchFragment,
    manufacturerProductBimLinkDetailFragment,
    manufacturerProductCatalogDetailFragment,
    manufacturerProductImageDetailFragment,
    manufacturerProductPropertyDetailFragment,
    manufacturerProductSpecDocDetailFragment,
    manufacturerProductVideoDetailFragment,
    manufacturerProductWebLinkDetailFragment,
    partnershipFragment,
} from '../fragments/product.fragments'

// gets all recent products across our content20
export const RecentProductsQuery = gql`
    query recentProductsQuery {
        listingSearch(
            input: {
                facets: [
                    { name: "isActive", values: ["true"] }
                    { name: "submissionStatus", values: ["Completed"] }
                    {
                        name: "listingLevels"
                        values: [
                            "Premium"
                            "Premium MasterSpec"
                            "PremiumMasterSpec"
                            "PremiumProprietary"
                        ]
                    }
                ]
                top: 4
                orderBy: "lastUpdated desc"
                skip: 0
                logEventSource: "AeRecentProducts"
            }
        ) {
            matches {
                firmId
                firmName
                categories
                productName
                firmLogoUrl
                listingId
                images {
                    filename
                }
            }
        }
    }
`

export const ProductSearchQuery = gql`
    query productSearchQuery(
        $manufacturerProductSearchInput: ManufacturerProductSearchInput!
    ) {
        listingSearch(input: $manufacturerProductSearchInput) {
            facets {
                name
                values {
                    value
                }
            }
            matches {
                ...listingMatchFragment
            }
            count
        }
    }
    ${listingMatchFragment}
`

export const RelatedProductsQuery = gql`
    query relatedProductsQuery(
        $manufacturerProductSearchInput: ManufacturerProductSearchInput!
    ) {
        listingSearch(input: $manufacturerProductSearchInput) {
            matches {
                ...listingMatchFragment
            }
            count
        }
    }
    ${listingMatchFragment}
`
export const ProductListingDetailsQuery = gql`
    query getListingDetail($listingIdInput: GetListingDetailInput!) {
        getListingDetail(input: $listingIdInput) {
            model
            productId
            listingId
            productName
            firmLogoUrl
            firmId
            firmName
            firmDisplayName
            firmPartnershipTypes
            categories
            productType
            submissionStatus
            isActive
            buildingTypes
            firstPublished
            lastPublished
            shortDescription
            longDescription
            sectionNumber
            sectionName
            type
            lastUpdated
            isForNonMasterspecFamily
            properties {
                ...manufacturerProductPropertyDetailFragment
            }
            images {
                ...manufacturerProductImageDetailFragment
            }
            videos {
                ...manufacturerProductVideoDetailFragment
            }
            firmPartnershipTypes
            webLinks {
                ...manufacturerProductWebLinkDetailFragment
            }
            catalogs {
                ...manufacturerProductCatalogDetailFragment
            }
            manufacturerDocs {
                ...manufacturerProductSpecDocDetailFragment
            }
            bimLinks {
                ...manufacturerProductBimLinkDetailFragment
            }
            partnershipLinks {
                ...partnershipFragment
            }
            assignedContactUsers {
                profileInfo {
                    firstName
                    lastName
                    phone
                }
                status
                email
            }
        }
    }
    ${manufacturerProductWebLinkDetailFragment}
    ${manufacturerProductImageDetailFragment}
    ${manufacturerProductVideoDetailFragment}
    ${manufacturerProductPropertyDetailFragment}
    ${manufacturerProductCatalogDetailFragment}
    ${manufacturerProductSpecDocDetailFragment}
    ${manufacturerProductBimLinkDetailFragment}
    ${partnershipFragment}
`

export const ListingsGetListingProductTypeProperties = gql`
    query listingsGetListingProductTypeProperties(
        $input: GetListingProductTypePropertiesInput!
    ) {
        listingsGetListingProductTypeProperties(input: $input) {
            categories
            properties {
                ...manufacturerProductPropertyDetailFragment
            }
        }
    }
    ${manufacturerProductPropertyDetailFragment}
`

export const ProductSearchAutosuggestQuery = gql`
    query listingAutoSuggest($input: ManufacturerProductAutoSuggestInput!) {
        listingAutoSuggest(input: $input) {
            result
            searchAfterKey
        }
    }
`
export const ProductCardAutosuggestQuery = gql`
    query listingCardsAutoSuggest($input: ListingCardsAutoSuggestInput!) {
        listingCardsAutoSuggest(input: $input) {
            productFamilyToProductTypes {
                productType
                parentProductFamily
                pTNodeId
                pTElementId
                familyElementId
                familyNodeId
                specAgentProductTypeId
            }
        }
    }
`
export const ProductTypeClashDetectionQuery = gql`
    query productTypeClashDetectionQuery(
        $input: ProductTypesClashDetectionInput!
    ) {
        clashDetection(input: $input) {
            message
            clashedProductTypes {
                productType
                productTypeParentAssemblies
            }
        }
    }
`

export const GetProductFlagForReviewQuery = gql`
    query productListingFlagForReviewQuery($projectId: String!) {
        getProductListingsFlaggedForReview(projectId: $projectId) {
            message
            items {
                projectId
                listingId
            }
        }
    }
`
